import { FC } from 'react'
import cx from 'classnames'

import { FormFieldSelectProps } from '../../form/fields/FormFieldSelect'
import { ActionButtonProps } from '../ActionButton'
import { ActionButtonVariant } from '../ActionButton/styled'
import Icon, { IconProps } from '../Icon'
import { AdsSearchFormProps } from '../../forms/AdsSearchForm'
import { LinkProps } from '../Link'

import * as SC from './styled'
import { AdsSortingFiltersVariant } from './styled'

type Item = {
  value: string
  icon: IconProps
}

export type AdsSortingFiltersProps = {
  className?: string
  title?: string
  error?: string
  searchLabel?: string
  termValue?: string
  searchFieldValue?: Array<Item>
  adsNumber?: string
  displaySelect?: FormFieldSelectProps
  orderSelect?: FormFieldSelectProps
  filterButton?: ActionButtonProps
  alertCreationButton?: ActionButtonProps
  searchForm?: AdsSearchFormProps
  isOpen: boolean
  variant?: AdsSortingFiltersVariant
  removeFilters?: LinkProps
}

const AdsSortingFilters: FC<AdsSortingFiltersProps> = ({
  className,
  title,
  searchLabel,
  termValue,
  searchFieldValue,
  adsNumber,
  displaySelect,
  orderSelect,
  filterButton,
  alertCreationButton,
  searchForm,
  isOpen,
  variant,
}) => {
  return (
    <SC.Wrapper className={cx('AdsSortingFilters', className)}>
      {(searchLabel || filterButton) && (
        <SC.Top>
          <SC.Search>
            <SC.SearchLabel>
              {searchLabel}
              {termValue && <SC.TermValue>{termValue}</SC.TermValue>}
            </SC.SearchLabel>
            {searchFieldValue && (
              <SC.SearchFieldValueList>
                {searchFieldValue?.map((item, index) => (
                  <SC.SearchFieldValueListItem key={index}>
                    <Icon {...item.icon} />
                    {item.value}
                  </SC.SearchFieldValueListItem>
                ))}
              </SC.SearchFieldValueList>
            )}
          </SC.Search>
          <SC.Actions>
            {alertCreationButton && (
              <SC.AlertCreationButton
                {...alertCreationButton}
                variant={ActionButtonVariant.quaternary}
              />
            )}
            {filterButton && (
              <SC.FilterButton
                {...filterButton}
                variant={ActionButtonVariant.secondary}
              />
            )}
          </SC.Actions>
        </SC.Top>
      )}
      <SC.Middle $variant={variant} $isOpen={isOpen}>
        {title && <SC.Title>{title}</SC.Title>}
        {searchForm && <SC.SearchForm {...searchForm} />}
      </SC.Middle>
      <SC.Bottom>
        {adsNumber && <SC.SortResult>{adsNumber}</SC.SortResult>}
        <SC.SelectWrapper>
          {displaySelect && <SC.DisplaySelectField {...displaySelect} />}
          {orderSelect && <SC.OrderSelectField {...orderSelect} />}
        </SC.SelectWrapper>
      </SC.Bottom>
    </SC.Wrapper>
  )
}

export default AdsSortingFilters
